import _CONSTANTS from '@toolproof-core/genesis/_data/lookups/constants';
import _MAPPINGS from '@toolproof-core/genesis/_data/lookups/mappings';
export const CONSTANTS = {
    ..._CONSTANTS,
    Persistence: {
        Buckets: {
            tp_resources: 'tp-resources',
            tp_workflows: 'tp-workflows',
        },
        Collections: {
            resources: 'resources',
            members: 'members',
        },
    },
    Engine: {
        Graphs: {
            GraphRunWorkflow: 'GraphRunWorkflow',
            GraphBuildWorkflow: 'GraphBuildWorkflow',
        },
    }
};
export const MAPPINGS = {
    ..._MAPPINGS,
    IdentifierNameToPrefix: {
        ..._MAPPINGS.IdentifierNameToPrefix,
        ToolStepKey: 'TOOL_STEP-',
        BranchStepKey: 'BRANCH_STEP-',
        WhileStepKey: 'WHILE_STEP-',
        ForStepKey: 'FOR_STEP-',
    },
};
